import { passwordlessEvaluation } from "./passwordlessEvaluation";

// add more here for experiments
const evidentlyFeatures = [
    ...passwordlessEvaluation
];

export default evidentlyFeatures;
